// TelcoTrack — Navolávání. Saved profile `sections.navolavani.view`.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { permissionAllows } from '@core/shared-bridge';
import { AuthService } from '../services/auth.service';

export const navolavaniGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.getCurrentUser();
  if (permissionAllows(user?.permissionProfile, 'navolavani', 'view')) return true;
  return router.createUrlTree(['/403']);
};
